export const FETCH_REGION_SUCCESS = 'regions/FETCH_REGION_SUCCESS';
export const FETCH_EDK_REGION_SUCCESS = 'regions/FETCH_EDK_REGION_SUCCESS';
